<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div id="login" class="login-root">
		<transition name="fade">
			<div v-if="performingRequest" class="loading">
				<div>
					<p><i class="fontello icon-spin5 mr-1"/><span v-html="progressMessage"/></p>
				</div>
			</div>
			<!--			<LoadingIndicator-->
			<!--				v-if="performingRequest"-->
			<!--				:text="progressMessage"-->
			<!--			/>-->
		</transition>
		<section>
			<div class="col1">
				<h1 style="color: white;">Qwoach</h1>
				<p>Eliminate administrative routine to focus on coaching</p>
			</div>
			<div class="col2" :class="{'signup-form': currentForm == 'signup'}">
				<form v-if="currentForm == 'login'" @submit.prevent>
					<h1>Welcome Back</h1>

					<label for="email1">Email</label>
					<input v-model.trim="email" type="text" id="email1" name="email"/>

					<label for="password1">Password</label>
					<input v-model.trim="loginForm.password" type="password" id="password1" name="password"
						   autocomplete="password"/>

					<button @click="login" class="button">Log In</button>

					<div class="extras mr-4" style="">
						<a @click="switchForm('resetPassword')">Forgot Password?</a>
						<!--						Need an account? Contact our support.-->
						<a @click="switchForm('signup')">Create an Account</a>
					</div>
				</form>
				<form v-if="currentForm == 'signup'" @submit.prevent>
					<div style="margin-bottom: 2rem;" class="padding-x">
						<h1 class="mb-2">Create your account</h1>
						<div class="row mx-0">
							<div>Step {{stepNumber}} of 2</div>
							<div class="layout-spacer"/>
							<div v-if="stepNumber == 2">
								<a @click="stepNumber = 1">Back</a>
							</div>

						</div>
					</div>

					<div v-if="stepNumber === 1" class="padding-x">
						<label for="name">Full Name</label>
						<input v-model.trim="signupForm.name" type="text" id="name" name="name" autocomplete="name"/>

						<label for="email2">Email</label>
						<input v-model.trim="email" type="text" id="email2" name="email" autocomplete="email"/>

						<label for="password2">Password</label>
						<input v-model.trim="signupForm.password" type="password" id="password2" name="password"
							   autocomplete="password"/>
						<button @click="onSignUpFormFilledIn" class="button mb-5">Continue</button>
						<div class="extras mr-4" style="padding-top: 14px;">
							<a @click="switchForm('login')">Log In</a>
						</div>
					</div>
					<div v-else>

						<div>
							<div class="mb-4">
								<div style="padding: 0 13px">

									<h4 v-if="isSpecialTrial">Start your free 6-Month Trial of Qwoach Essentials
										Monthly</h4>
									<h4 v-else-if="isSpecialContributor">Start your special Life-Time Discount of Qwoach
										Contributor Monthly</h4>
									<h4 v-else>Join Qwoach Contributors community</h4>

									<div v-if="isPaddleLoading" class="text-center">
										<i class="fontello icon-spin5 mr-1"/>Loading...
									</div>
									<div v-else class="card p-2 mt-5">
										<div class="mb-2"><b>{{planName}}</b></div>
										<div>Pay today: <span class="strike-through">${{this.saveNow}}</span> ${{this.payNow}} {{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> </div>
										<div>Pay in 6 months: <span v-if="saveThen" class="strike-through">${{this.saveThen}}</span> ${{this.payThen}} {{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> </div>
										<div class="text-muted mt-2">
											<small>
												<div v-if="taxThen">

													<div>
														*The prices above include Sales Tax.
														<ToolTipView :analyticsProps="tooltipAnalyticsProps" >
															Depending on your country, the price can include a standard tax called VAT which is regulated by the government of your country.
															<br/><br/>
															If you are a registered businesses, you can enter your VAT number below to remove the tax from the price.
														</ToolTipView>
													</div>

													<div>Add your VAT number below to remove the Tax.</div>
												</div>
											</small>
										</div>
									</div>
								</div>
							</div>
<!--							<div>-->
<!--								<el-button @click="testPaddleHook">Paddle Webhook</el-button>-->
<!--								<el-button @click="onPaymentSuccess">Payment success</el-button>-->
<!--								<el-button @click="testPaddleHookAndPaymentSuccess()">Both</el-button>-->
<!--							</div>-->
							<div class="checkout-container relative">

<!--								<div v-if="!isPaddleLoading" class="text-muted text-note absolute"-->
<!--									 style="bottom: 0; left: 0; right: 0; height: 170px; width:450px; background: white; padding: 1.3rem">-->
<!--									<span v-if="isSpecialTrial">By clicking "Subscribe Now", I agree to the Qwoach <a href="https://qwoach.com/terms" target="_blank">Terms of Use</a>, and give Qwoach permission to charge my credit card for ${{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months trial is up.</span>-->
<!--									<span v-else>By clicking "Subscribe Now", I agree to the Qwoach <a href="https://qwoach.com/terms" target="_blank">Terms of Use</a>, and give Qwoach permission to charge my credit card for the discounted ${{this.payNow}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> for the next 6 months and then special price of ${{this.payThen}}{{this.currency}}/{{this.payIntervalType}}<span v-if="taxThen">*</span> after the 6 months period is up.</span>-->
<!--									<div v-if="taxThen" class="mt-4">*Have a VAT number? Enter it above to remove the Sales Tax from the price.</div>-->

<!--									<div class="sc-bwzfXH bDcmNo my-5">-->
<!--										<div font-size="10px" class="sc-cSHVUG ktEtCx">This order process is conducted by our online reseller &amp; Merchant of Record Paddle.com.</div>-->
<!--										<div font-size="1.2em" class="sc-cSHVUG euKYoy">Your data will be shared with Qwoach LLC for product fullfillment. Paddle.com Market Ltd, Judd House, 18-29 Mora Street, London EC1V 8BT.</div>-->
<!--										<a font-size="1.2em" href="https://paddle.com/legal-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Terms &amp; Conditions</a> <span class="sc-eNQAEJ gIIoKl">|</span> <a font-size="1.2rem" href="https://paddle.com/privacy-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Privacy Policy</a>-->
<!--									</div>-->
<!--								</div>-->

							</div>
						</div>


					</div>


				</form>
				<form v-if="currentForm == 'resetPassword'" @submit.prevent class="password-reset">
					<div v-if="!passwordResetSuccess">
						<h1>Reset Password</h1>
						<p>We will send you an email to reset your password</p>

						<label for="email3">Email</label>
						<input v-model.trim="email" type="text" id="email3"/>

						<button @click="resetPassword" class="button">Submit</button>

						<div class="extras mr-4" style="padding-top: 14px;">
							<a @click="switchForm('login')">Back to Log In</a>
						</div>
					</div>
					<div v-else>
						<h1>Email Sent at {{email}}</h1>
						<p>check your email for a link to reset your password</p>
						<button @click="switchForm('login')" class="button">Back to login</button>
					</div>
				</form>
				<transition name="fade">
					<div v-if="errorMsg" class="error-msg padding-x" style="text-align: left; max-width: 450px; margin: 0 auto;">
						<p v-html="errorMsg"></p>
					</div>
				</transition>
			</div>
		</section>

<!--		<div class="paddle-notice sc-bwzfXH bDcmNo"><div font-size="1.2rem" class="sc-cSHVUG ktEtCx">This order process is conducted by our online reseller &amp; Merchant of Record Paddle.com, who also handle all customer service inquiries and returns.</div><div font-size="1.2rem" class="sc-cSHVUG euKYoy">Your data will be shared with Paddle.com for product fullfillment. Paddle.com Market Ltd, Judd House, 18-29 Mora Street, London EC1V 8BT.</div><a font-size="1.2rem" href="https://paddle.com/legal-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Terms &amp; Conditions</a> <span class="sc-eNQAEJ gIIoKl">|</span> <a font-size="1.2rem" href="https://paddle.com/privacy-buyers/" target="_blank" rel="noopener noreferrer" class="sc-gZMcBi biITmK">Paddle.com Privacy Policy</a></div>-->
	</div>
</template>

<script>

	import {logError, validateEmail} from "@/utils/helpers";
	import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

	import BaseComponent from "@/core/components/BaseComponent.vue";

	export default {
		name: "LoginViewOld",
		extends: BaseComponent,
		components: {ToolTipView, LoadingIndicator},
		props: {
			specialId: String,
			tooltipAnalyticsProps: Object
		},
		watch:{
			specialId:{
				immediate: true,
				handler(){
					this.onSpecialIdChanged()
				}
			}
		},
		data() {
			return {
				planId: 601238,
				currentForm: 'signup',
				performingRequest: false,
				passwordResetSuccess: false,
				errorMsg: '',
				isPaddleLoading: false,
				progressMessage: "Loading...",
				saveNow:"",
				saveThen:"",
				payNow:"",
				payThen:"",
				currency:"",
				payIntervalType:"",
				payIntervalLength:"",
				taxNow:0,
				taxThen:0,
				planName:"",

				stepNumber: 1,
				email: '',
				location: {},
				loginForm: {
					password: ''
				},
				signupForm: {
					name: '',
					title: '',
					password: ''
				},
				passwordForm: {}
			}
		},
		methods: {

			onSpecialIdChanged(){
				switch (this.specialId) {
					case "infostack":
						this.planId = 601237
						break;
					case "contributor":
						this.planId = 601238
						break;
					default:
						this.planId = 762957//601238
				}
			},
			resetPassword() {
				this.performingRequest = true
				this.errorMsg = ''
				this.dataManager.sendPasswordResetEmail(this.email)
					.then(() => {
						this.performingRequest = false
						this.passwordResetSuccess = true
					}).catch(error => {
					console.log(error)
					this.passwordResetSuccess = false
					this.performingRequest = false
					this.errorMsg = error.message
				})
			},
			switchForm(val) {
				this.errorMsg = ''
				this.currentForm = val
				this.passwordResetSuccess = false
			},
			login() {
				this.errorMsg = ''
				this.performingRequest = true
				this.$server.signInWithEmailAndPassword(this.email, this.loginForm.password)
					.then(() => {
						this.performingRequest = false
						this.go("CoachingProcessMainCoach")
					}).catch(error => {
					this.performingRequest = false
					this.errorMsg = error.message
					logError(error)
				})
			},
			async onSignUpFormFilledIn() {
				this.errorMsg = ''
				if (!this.signupForm.name.length) {
					this.errorMsg = 'Name is required'
					return
				}
				if (!this.email.length) {
					this.errorMsg = 'Please provide email'
					return
				}

				if (!validateEmail(this.email)) {
					this.errorMsg = 'Email must be formatted properly'
					return
				}
				if (this.signupForm.password.length === 0) {
					this.errorMsg = 'Password is required'
					return
				}
				if (this.signupForm.password.length < 6) {
					this.errorMsg = 'Password is too short<br/>(6 characters minimum)'
					return
				}
				this.performingRequest = true
				try {
					if (await this.$dataManager.isUserExist(this.email)) {
						this.errorMsg = 'User with this email already exists. Try to login instead.'
						this.performingRequest = false
						return
					}
					this.location = await this.$dataManager.apiPostZip()
					this.performingRequest = false
					this.stepNumber = 2
					this.$nextTick(() => this.showPaddle())
				} catch (error) {
					this.performingRequest = false
					this.handleError(error)
				}
			},

			createProfileData() {
				return {
					email: this.email,
					password: this.signupForm.password,
					name: this.signupForm.name,
					isRecoveryCoach: true,
					timezone: this.timezoneComputed,
				}
			},
			// async testPaddleHookAndPaymentSuccess(){
			// 	await Promise.all([
			// 		this.onPaymentSuccess(),
			// 		delay(1000, () => this.testPaddleHook())
			// 	])
			// },
			//
			async testPaddleHook(){
				await Promise.all([
					// this.testPaddleHookSubscriptionCreated(),
					this.testPaddleHookPaymentSucceeded()
				])
			},
			async testPaddleHookPaymentSucceeded(){
				console.log("testPaddleHookPaymentSucceeded: started")
			},
			// async testPaddleHookSubscriptionCreated() {
			// 	console.log("testPaddleHookSubscriptionCreated: started")
			// },

			async showPaddle() {
				this.isPaddleLoading = true
				document.removeEventListener("paddle_checkout_event", this.onPaddleEvent.bind(this));
				document.addEventListener("paddle_checkout_event", this.onPaddleEvent.bind(this));
				let amplitudeDeviceId = this.$analyticManager.getAmplitudeDeviceId()
				window.Paddle.Checkout.open({
					method: 'inline',
					frameTarget: 'checkout-container',
					frameInitialHeight: 416,
					frameStyle: 'width:450px; min-width:450px; background-color: white; border: none;',
					email: this.email,
					country: this.location.countryCode,
					postcode: this.location.zip,
					disableLogout: true,
					allowQuantity: false,
					product: this.planId,
					passthrough: {amplitudeDeviceId},
					successCallback: this.onPaymentSuccess.bind(this)
				})
			},

			onPaddleEvent(data) {
				data = data.detail
				this.isPaddleLoading = false
				console.log("onPaddleEvent: data3 = ", data)

				let firstPriceData = data.eventData.checkout.prices.customer
				let recurringPriceData = data.eventData.checkout.recurring_prices.customer
				let recurringPriceIntervalData = data.eventData.checkout.recurring_prices.interval
				let currency = firstPriceData.currency

				let taxFirst = Number(firstPriceData.total_tax);
				let totalFirst = Number(firstPriceData.total);
				let subtotalFirst = totalFirst - taxFirst
				subtotalFirst = subtotalFirst.toFixed(2)

				let totalThen = Number(recurringPriceData.total)
				let taxThen = Number(recurringPriceData.total_tax)
				let intervalTypeThen = recurringPriceIntervalData.type
				let intervalCountThen = Number(recurringPriceIntervalData.length)

				let taxPercentage = taxThen / (totalThen - taxThen)

				console.log("taxPercentage = ", taxPercentage)

				this.taxNow = taxFirst
				this.taxThen = taxThen
				this.currency = currency
				this.payNow = totalFirst
				this.payThenTotal = totalThen
				this.payThen = totalThen
				this.payThenTax = taxThen
				this.saveNow = this.payThen
				this.payIntervalType = intervalTypeThen
				this.payIntervalLength = intervalCountThen

				if(this.isSpecialTrial){
					this.planName = "Qwoach Essentials plan"
				} else {
					this.planName = "Get ALL features of Qwoach"
					this.saveNow = 89 + 89 * taxPercentage
					this.payThen = 19 + 19 * taxPercentage
					this.saveThen = this.saveNow
				}




				// if (data.eventData.checkout.recurring_prices) {
				// 	var recurringCurrency = data.eventData.checkout.recurring_prices.customer.currency;
				// 	var recurringTotal = data.eventData.checkout.recurring_prices.customer.total;
				// 	var intervalType = data.eventData.checkout.recurring_prices.interval.type;
				// 	var intervalCount = data.eventData.checkout.recurring_prices.interval.length;
				//
				// 	if(intervalCount > 1) {
				// 		var recurringString = '<div class="is-line-label">Then</div><div class="is-line-value">'+recurringCurrency+" "+recurringTotal+" / "+intervalCount+" "+intervalType+"s</div>";
				// 	}
				// 	else {
				// 		var recurringString = '<div class="is-line-label">Then</div><div class="is-line-value">'+recurringCurrency+" "+recurringTotal+" / "+intervalType+"</div>";
				// 	}
				//
				// 	document.getElementById("recurringPrice").innerHTML = recurringString;
				// }
			},


			async onPaymentSuccess(response) {
				console.log("onPaymentSuccess: response = ", response)
				this.showProgress("Processing your order...<br/>Don't refresh this tab.")
				let profileData = this.createProfileData()
				try {
					await this.$dataManager.apiPostCreateCoachProfile(profileData)
					let coachProfile = await this.$dataManager.login(profileData.email, profileData.password)
					let stopObserver = await this.$dataManager.onSnapshotUserSubscription(coachProfile.id, (subscription, error) => {
						console.log("onSnapshotUserSubscription: subscription = ", subscription, ", error = ", error)
						if(error) {
							this.handleError(error)
							stopObserver()
							this.hideProgress()
							return
						}
						if (subscription && subscription.isStarted()) {
							stopObserver()
							this.go("CoachingProcessMainCoach")
						}
					})
				} catch (error) {
					this.hideProgress()
					this.handleError(error)
				}

			},

			showProgress(msg = "Loading...") {
				this.progressMessage = msg
				this.performingRequest = true
			},
			hideProgress() {
				this.performingRequest = false
				this.progressMessage = "Loading..."
			},


		},

		computed: {
			isSpecialTrial() {
				return this.planId === 601237
			},
			isSpecialContributor() {
				return this.planId === 601238
			}
		}
	}
</script>

<style src="@/assets/scss/app.scss" lang="scss" scoped/>

<style lang="scss" scoped>
	body{
		background: white !important;

	}
	.login-root {
		.padding-x{
			padding: 0 13px;
		}
		.text-note {
			font-size: 12px;
		}

		.paddle-notice{
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
		}

		.bDcmNo {
			font-size: 10px;
			background-color: rgb(255, 255, 255);
			height: auto;
			text-align: center;
			width: auto;
			border-width: 1px;
			border-style: solid;
			border-color: rgb(235, 236, 240);
			border-image: initial;
			border-radius: 4px;
			padding: 12px 16px 16px;
		}
		.ktEtCx {
			color: rgb(147, 147, 168);
			display: block;
			font-family: Lato, Helvetica, "Trebuchet MS", "Adobe Heiti Std", "Segoe UI", sans‑serif;
			font-size: 1.2em;
			/*font-weight: 400;*/
			line-height: 20px;
			margin-bottom: 8px;
			text-decoration: none;
		}
		.euKYoy {
			color: rgb(147, 147, 168);
			display: block;
			font-family: Lato, Helvetica, "Trebuchet MS", "Adobe Heiti Std", "Segoe UI", sans‑serif;
			font-size: 1.2em;
			/*font-weight: 400;*/
			line-height: 20px;
			margin-bottom: 8px;
			text-decoration: none;
		}
		.biITmK {
			color: rgb(6, 198, 104);
			display: inline;
			font-size: 1.2em;
			/*font-weight: 400;*/
			line-height: 2em;
			text-decoration: underline;
		}
	}
</style>

